// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"Z_-z","subtitle":"__-z","wrapper":"aaa-z","leftArrow":"baa-z","rightArrow":"caa-z"};